import type { Page } from '../schemas/validation';
import type { PublishStatus } from '../hooks/useUnpublishedSummary';

/**
 * Whether the page editor should show Publish / Republish.
 * Prefer backend status (includes layout + slug + components); fall back to component snapshot compare.
 */
export function shouldShowPagePublishButton(page: Page, backendStatus?: PublishStatus): boolean {
  if (backendStatus === 'never_published' || backendStatus === 'changed') {
    return true;
  }
  if (backendStatus === 'up_to_date') {
    return false;
  }

  if (!page.publishedAt) {
    return true;
  }

  return page.components !== page.publishedComponents;
}
